import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import { GET_CONSUMER_TICKETS } from "./actionTypes";

import { setConsumerTickets, apiError } from "./actions";

import axios from "axios";

function* getConsumerTickets({ payload: { consumerId } }) {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/consumer/${consumerId}/tickets`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setConsumerTickets(consumerId, response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(consumerId, message));
  }
}

export function* watchGetConsumerTickets() {
  yield takeEvery(GET_CONSUMER_TICKETS, getConsumerTickets);
}

function* authSaga() {
  yield all([fork(watchGetConsumerTickets)]);
}

export default authSaga;
